// Airtable field IDs used by the frontend (mirror of backend fields.py)
export const FIELDS = {
  CASE_ID: "fldyApL9pG0CB8jgE",
  NAME: "fldIggDKuN2oUPMg7",
  PHONE: "fldRw8OMtQf4E16Ly",
  LEAD_STAGE: "fldJquPyHv7n86o8q",
  HL_RM: "fldu3X0XcYDMLxeFL",
  EMAIL: "fld6xIMEil2d9lbRk",
  BORROWER: "fld1KwcMYkJ9pu3P6",
  CO_BORROWER: "fldkQv96kQntrajc5",
  CO_BORROWER_AGREEMENT: "fldw9Nkpx3j8XNbnj",
  TRUVA_NONTRUVA: "fld4QyMrKTo739NaR",
  PROPERTY_FINALISED: "fldGD3C4FM7P7vVB1",
  LOAN_AMOUNT: "fldes6hIr4hcyWEei",
  LOAN_TENURE: "fldmvCsmjr4DtGMuU",
  AGREEMENT_VALUE: "fldJEsOYW3lZrbc64",
  BANK_NAME: "fldK2jzENP5fdZq1n",
  BANK_TYPE: "fldbosXBsWnCILN4K",
  PARTNER_COMPANY: "fldAB3PZj1EYxH6kA",
  EXPECTED_DISB_QUARTER: "fldzxqggcV68qd3Fd",
  DISBURSED_AMOUNT: "fldrkiAxAxZk4o0Cr",
  DISBURSEMENT_DATE: "fldQZsdghGxYkK9El",
  PROPERTY_TRUVA: "flduER4aEOHXb1X5c",
  MICRO_MARKET: "fldEtmZh8GGlQUa77",
  PROPERTY_NAME_OOT: "fldBUQQlSG6J5ywP6",
  FOLLOW_UP_DATE: "flduEnheSL9jRuwDK",
  LAST_CONVERSATION: "fldQ6pU2mKsL6e9JR",
  CONSULTATION_STATUS: "fld3jXU6PgM6L1dXN",
  CONSULTATION_CALL_DATE: "fldOzsb1bKgzIH36I",
  STATUS: "fldXlJUFdSS4ZYRzi",
  LOST_REASON: "fldW32nXJ3ifR4BLw",
  NOTES: "fldFxK28A73zVqZDy",
  CASE_HISTORY: "fldPDqmlND0CKLfZe",
  TOTAL_COMMISSION: "fldb7FAfOHSsOspS3",
  CASHBACK_YN: "fld6ywR3beNNreXU3",
  CASHBACK: "fldNH2C63CjDRBV2R",
  NET_COMMISSION: "fldLK9AjXH6pWHOUG",
  DRIVE_FOLDER_LINK: "fldHjILefIlMNZMbL",
  BORROWER_PROFILE: "fldpgCKNlBgKTgt7W",
  CO_BORROWER_PROFILE: "fldLTIbngB2EzmKVn",
  DIRECTOR_PAY_TYPE: "fldtYBEjOM6y0OktF",
  NEXT_ACTION: "fldqZxJWbc3AS3abz",
  RM_CONFIDENCE: "fldv18R8CCUzwUeM9",
  LEAD_SOURCE: "fldxN4PfuPd9dr4Xo",
  PARTNER_SPOC: "fldYCwx2HQH0Fle3y",
  CONSULTATION_TAKEN_BY: "fldwi1ZOYAeF0Fm6v",
  CONSULTATION_NOTES_LINK: "fldMqEa6OxQNIkxl2",
  CONSULTATION_RECORDING_LINK: "fldxImZbhTTPRoRpb",
  BUYER_LAWYER_LINK: "fldb4urR9AuTQRie7",
  TRI_PARTY_MOU: "fldvmwCYhfooaciie",
  REGISTRATION_DATE: "fldYlznCqJbIT7RCR",
  BUYER_HANDOVER_DATE: "fld7tfHXSSFy084Zz",
  SELLER_SIDE_DOCS: "fldJnbECYLP9Q38Xv",
  RM_FROM_PROPERTY: "fldadrbOkt1GgPt0h",
};

export const LOST_STAGE = "Lost";
export const DISBURSED_OR_LATER = ["Disbursed", "Invoice Raised", "GST", "Commission Collected"];
